import { render } from "./LSWalletView.vue?vue&type=template&id=0a6ac1b7&scoped=true"
import script from "./LSWalletView.vue?vue&type=script&lang=js"
export * from "./LSWalletView.vue?vue&type=script&lang=js"

import "./LSWalletView.vue?vue&type=style&index=0&id=0a6ac1b7&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a6ac1b7"]])

export default __exports__